import { put, call } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getSchoolMoneyLocalStoreData, saveSchoolMoneyLocalStoreData } from "state/localStore";
import { fetchShopItemsSucceeded } from "state/school_money/actions";

import ShopItem from "state/school_money/entities/ShopItem";

export default function* fetchShopItemsSaga(action) {
  const forceApiRefresh = action.payload.forceApiRefresh;
  let shopData;

  if(!forceApiRefresh) {
    shopData = getSchoolMoneyLocalStoreData("shop");
  }

  if(shopData === undefined) {
    const response = yield call(sendSchoolMoneyDataRequest, "get_shop_items");
    shopData = response.data.shop_items;
    saveSchoolMoneyLocalStoreData("shop", shopData);
  }

  const shopItemsByID = arrayToEntityMap(ShopItem.fromAppserver, shopItem => shopItem.id, shopData);
  yield put(fetchShopItemsSucceeded(shopItemsByID));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchShopItemsSaga.js